import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import css from '../index.scss';
import searchBoxCss from '../styles/search.scss';
import DropDownList from '../../dropdown-list/index';
import { FULL_WIDTH } from '../../dropdown-list/constant';
import messages from '../messages';
import classEnum from '../../../containers/class-roll/constants';
import TextInput from '../../text-input';

const AssignCourseFilter = (props) => {
    const { intl,
        yearGroups,
        countries,
        handleOnYearGroupChange,
        handleOnCountryChange,
        handleOnSearchCourse,
        searchQuery,
        disableSearch,
        disableYearGroup,
        forLegacy,
        selectedYearGroupId,
        isLoadingCountryYearGroups,
        forManageDefaultCourses,
        isNewCoursesSelected,
        selectedCountryId,
        isLegacySelected
    } = props;

    const countriesList = countries.slice(0);

    if (forLegacy) {
        countriesList.unshift({
            name: intl.formatMessage(messages.schoolCourses),
            code: classEnum.SCHOOL_COURSES
        });
    }

    const clearText = true;

    const getSubHeading = () => {
        if (isNewCoursesSelected) {
            return intl.formatMessage(messages.newCourses);
        } else if (isLegacySelected) {
            return intl.formatMessage(messages.courses);
        }

        return intl.formatMessage(messages.skillQuests);
    };

    return (<div>
        <div className={css.defaultCourse}>
            <div className={css.heading}>{intl.formatMessage(messages[forManageDefaultCourses ? 'startCourse' : 'setDefaultCourse'])}</div>
            <div className={css.subHeading}>{getSubHeading()}</div>
            <DropDownList
                name="countries"
                onChange={handleOnCountryChange}
                optionKey="code"
                options={countriesList}
                optionText="name"
                placeholder={intl.formatMessage(messages.defaultOptionCountry)}
                value={selectedCountryId}
                variant={FULL_WIDTH}
            />
            <DropDownList
                disabled={disableYearGroup}
                isLoading={isLoadingCountryYearGroups}
                name="yearGroups"
                onChange={handleOnYearGroupChange}
                optionKey="yearGroupEnum"
                options={yearGroups}
                optionText="longName"
                placeholder={intl.formatMessage(messages.selectGroup)}
                value={selectedYearGroupId}
                variant={FULL_WIDTH}
            />
            <div className={css.searchContainer}>
                <TextInput
                    clearText={clearText}
                    css={searchBoxCss}
                    disabled={disableSearch}
                    handleOnChange={handleOnSearchCourse}
                    placeholder={intl.formatMessage(messages.searchCourse)}
                    type="text"
                    value={searchQuery}
                />
            </div>
        </div>
    </div>);
};

AssignCourseFilter.propTypes = {
    intl: intlShape.isRequired,
    yearGroups: PropTypes.array,
    countries: PropTypes.array,
    handleOnYearGroupChange: PropTypes.func,
    handleOnCountryChange: PropTypes.func,
    handleOnSearchCourse: PropTypes.func,
    searchQuery: PropTypes.string,
    disableSearch: PropTypes.bool,
    disableYearGroup: PropTypes.bool,
    forLegacy: PropTypes.bool,
    isLoadingCountryYearGroups: PropTypes.bool,
    selectedYearGroupId: PropTypes.string,
    selectedCountryId: PropTypes.string,
    forManageDefaultCourses: PropTypes.bool,
    isNewCoursesSelected: PropTypes.bool,
    isLegacySelected: PropTypes.bool
};


AssignCourseFilter.defaultProps = {
    forManageDefaultCourses: false
};

export default injectIntl(styleable(css)(AssignCourseFilter));



// WEBPACK FOOTER //
// ./app/components/assign-course-upf/pages/assign-course-filter.js